//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/build/client.js";

//
// Component
//

export function initialiseSearchForm(searchForm: HTMLFormElement)
{
	const queryTypeSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(searchForm, `select[name="qt"]`);

	const extraSettingsGroups = searchForm.querySelectorAll(".extra-settings");

	initialiseForm(searchForm);

	queryTypeSelect.addEventListener("change",
		() =>
		{
			for (const extraSettingsGroup of extraSettingsGroups)
			{
				const inputs = extraSettingsGroup.querySelectorAll<HTMLInputElement>("input, select");

				const enabled = queryTypeSelect.value == "all" || extraSettingsGroup.classList.contains(queryTypeSelect.value);

				enabled ? extraSettingsGroup.classList.add("show") : extraSettingsGroup.classList.remove("show");

				for (const input of inputs)
				{
					input.disabled = !enabled;
				}
			}
		});

	searchForm.classList.add("initialised");
}

export function initialiseSearchForms()
{
	const searchForms = document.querySelectorAll<HTMLFormElement>(".component-search-form:not(.initialised)");

	console.log("[SearchForm] Initialising " + searchForms.length +  " instances...");

	for (const searchForm of searchForms)
	{
		try
		{
			initialiseSearchForm(searchForm);
		}
		catch (error)
		{
			console.error("[SearchForm] Error initialising:", searchForm, error);
		}
	}
}